import { useEffect, useState } from "react";

import {
  ArrowButton,
  Label,
  TableMetadata,
  useTable,
} from "@king-ict/eupisi-ui/components";
import { ExportTypeEnum } from "@king-ict/eupisi-ui/models";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

import { getFaqGroupListExport, getGroupList } from "../../api/Faq/FaqApi";
import { SearchCard, ContentArea, ListTable } from "../../components";
import { ToolbarTop } from "../../components/ToolbarTop";
import { Group, FaqApplicationDisplay } from "../../models/Faq";
import { faqGroupEditUrl, faqGroupDetailUrl } from "../../routes/routes";

export function FaqGroupList() {
  const { t } = useTranslation();
  const history = useHistory();

  const [tableData, setTableData] = useState<Group[]>([]);

  const tableMetadata: TableMetadata<Group> = {
    rowKey: "id",
    columns: [
      {
        columnKey: "name",
        header: t("common.faq.name"),
        accessor: (item: Group) => {
          return <div>{item.name}</div>;
        },
      },
      {
        columnKey: "faqApplicationDisplayId",
        header: t("common.faq.applicationDisplay"),
        accessor: (item: Group) => {
          return (
            <div>
              {t(
                "common.faq.faqApplicationDisplay." +
                  FaqApplicationDisplay[item.faqApplicationDisplayId]
              )}
            </div>
          );
        },
      },
      {
        columnKey: "status",
        header: t("common.faq.active"),
        accessor: (item: Group) => {
          return (
            <div className={"d-flex align-center"}>
              <Label
                color={item.status ? "success" : "noted-2"}
                className="text-center"
                outline={false}
              >
                {item.status ? t("common.yes") : t("common.no")}
              </Label>
            </div>
          );
        },
      },
      {
        columnKey: "details",
        header: "",
        accessor: (item: Group) => {
          return (
            <div className={"text-right"}>
              <ArrowButton
                ariaLabel={t("common.details")}
                onClick={() => handleDetailsClicked(item.id)}
              />
            </div>
          );
        },
      },
    ],
    rowToolTip: () => undefined,
  };

  const [tableProps] = useTable({
    metadata: tableMetadata,
    data: tableData,
    pagination: false,
    paginationPage: undefined,
    paginationPageSize: undefined,
    totalItems: 1,
    defaultSort: {},
  });

  useEffect(() => {
    (async () => {
      var groupList = await getGroupList();
      if (groupList !== null) {
        setTableData(groupList);
      }
    })();
  }, []);
  const handleDetailsClicked = (id?: number) => {
    if (id) {
      history.push(faqGroupDetailUrl(id!));
    }
  };
  const handleNewGroupClicked = () => {
    history.push(faqGroupEditUrl(0));
  };
  const handleDownloadClicked = async (exportType: ExportTypeEnum) => {
    await getFaqGroupListExport(exportType);
  };

  return (
    <ContentArea>
      <ToolbarTop
        showAdd={"show"}
        showBack={"hide"}
        onClickAdd={handleNewGroupClicked}
        pageTitle={t("common.faq.groupPageName")}
      ></ToolbarTop>
      <SearchCard hideSearchBox={true}></SearchCard>
      <ListTable
        tableProps={tableProps}
        onClickDownload={(exportType: ExportTypeEnum) =>
          handleDownloadClicked(exportType)
        }
        showDownload
      />
    </ContentArea>
  );
}
